import { render, staticRenderFns } from "./ModalListHSBA.vue?vue&type=template&id=c531d11c"
import script from "./ModalListHSBA.vue?vue&type=script&lang=js"
export * from "./ModalListHSBA.vue?vue&type=script&lang=js"
import style0 from "./ModalListHSBA.vue?vue&type=style&index=0&id=c531d11c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports